import { useEffect, useRef } from 'react';
import { ContextHolder } from '@frontegg/rest-api';
import AuthService from '../services/auth.service';

export default function Logout() {
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const authService = AuthService.getInstance();
    const params = new URLSearchParams(window.location.search);

    // Clear all auth state
    sessionStorage.removeItem('plb_auth_state');
    sessionStorage.removeItem('plb_handoff_token');
    document.cookie = 'plb_custom_origin=; Max-Age=0; path=/';
    document.cookie = 'plb_custom_origin_token=; Max-Age=0; path=/';
    document.cookie = 'plb_custom_origin_tenant=; Max-Age=0; path=/';
    authService.handoffToken = null;
    authService.plbAuthState = null;
    try { ContextHolder.setAccessToken(null as any); } catch (e) { /* */ }

    // Determine where to go next — don't call Frontegg's logout()
    // because it immediately redirects to /login before we can act.
    if (authService.isCustomDomain) {
      // On custom domain: IdP and Frontegg sessions are already killed
      // by the redirect chain. Clear plb_sso_attempted so the next page
      // load triggers a fresh SSO flow (safe because IdP session is dead).
      sessionStorage.removeItem('plb_sso_attempted');
      // Redirect to root — AuthService constructor will start SSO flow
      window.location.replace('/');
    } else {
      // On main domain: check for ssoLogout param to kill IdP session.
      const ssoLogout = params.get('ssoLogout');
      const returnTo = params.get('returnTo');
      if (ssoLogout) {
        window.location.replace(ssoLogout);
      } else if (returnTo) {
        window.location.replace(returnTo);
      } else {
        window.location.replace('/login');
      }
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-gray-500">Logging out...</div>
    </div>
  );
}
